<template>
  <div class="publish_containter">
    <div class="navbar">
      <van-nav-bar :title="titlename" left-arrow @click-left="onClickLeft" />
    </div>

    <div class="publishbox">
      <div class="currentcircle" v-if="circlecome=='true'">
        <img :src="circleicon" />
        <span>{{circlename}}</span>
      </div>

      <div v-else>
        <!--  <div class="currentcircle" @click.stop="showPopup" v-if="currentshow || circleid!=0"> -->
        <div class="currentcircle" @click.stop="showPopup" v-if="circleid!=0">
          <span class="cuIcon-right righticon"></span>
          <img :src="circleicon" />
          <span>{{circlename}}</span>
        </div>
      </div>

      <textarea placeholder="说一说你的想法" v-model="textvalue" @input="verify" maxlength="500"></textarea>
    </div>

    <div class="videoshowbox" v-if="videofile.length>0">
      <span class="closespan" @click="clearvideo">
        <van-icon name="clear" />
      </span>
      <div v-if="videofile.length>0">
        <video style="width:100%; height:208px" controls preload="auto">
          <source :src="videofile[0].content" />
        </video>
      </div>
    </div>

    <div class="publishimgbox" v-if="fileList.length>0">
      <van-uploader
        v-model="fileList"
        multiple
        :max-count="9"
        preview-size="6rem"
        v-if="fileList.length>0"
        :after-read="afterRead"
        :before-delete="deleteImg"
      />
    </div>

    <div class="publishdown">
      <div
        class="choosecircle"
        @click.stop="showPopup"
        v-if="wxzcircle == true && circlecome=='false'"
      >
        <img src="../../assets/images/dynamic_icon_qz.png" />
        <span>添加圈子</span>
      </div>

      <!-- <button bindtap="ceshila">这个是测试测试</button> -->

      <div class="publishhandle">
        <div class="publishbtn">
          <!-- bindtap="onSendTap"-->
          <button class="cu-btn bg-green shadow-blur cu-btn-fsbtn" @click="updatatogo">发布</button>
        </div>

        <div class="handleiconbox">
          <div class="handleicon01" v-if="fileList.length==0 && videofile.length==0">
            <van-uploader v-model="videofile" accept="video/*" :after-read="videoRead">
              <img src="../../assets/images/dynamic_icon_video.png" />
            </van-uploader>
          </div>

          <div class="handleicon01" v-else>
            <img src="../../assets/images/dynamic_icon_video_disable.png" />
          </div>

          <div class="handleicon02" v-if="fileList.length==0 && videofile.length==0">
            <van-uploader
              v-model="fileList"
              multiple
              :max-count="9"
              :after-read="afterRead"
              :before-delete="deleteImg"
            >
              <img src="../../assets/images/dynamic_btn_pic_normal.png" />
            </van-uploader>
          </div>

          <div class="handleicon02" v-else>
            <img src="../../assets/images/dynamic_btn_pic_disable.png" />
          </div>
        </div>
      </div>
    </div>

    <!--选择圈子-->
    <van-popup v-model="showOncircle" position="bottom" :style="{ height: '100%' }">
      <div class="xuanzetitle">选择圈子</div>
      <div class="choosecirclebox">
        <div class="nochoosecircle">
          <div class="circle-cell">
            <div class="circle-cell-pic">
              <img :src="circleIconNothing" />
            </div>
            <div class="circle-cell-name">
              <div class="cname">不发到任何圈子</div>
            </div>
            <div class="circle-cell-fllow" v-if="wxzcircle">
              <button>已选择</button>
            </div>
            <div
              class="circle-cell-fllow circle-cell-fllowed"
              data-cid="0"
              @click.stop="getchoosecircle"
              v-else
            >
              <button>选择</button>
            </div>
          </div>
        </div>

        <div class="followtitlebox">
          <div class="followtitle">我关注的</div>
        </div>

        <div class="followmain">
          <!-- scroll-view -->
          <div
            class="circlebigleftbox"
            style="height:26.08108108108108rem;"
            bindscrolltolower="onReachBottom02"
          >
            <div class="scroll-box">
              <div class="nofollowbox" v-if="nofollow">
                <div class="nofollowpic">
                  <img :src="circleIconWu" />
                </div>
                <div class="nofollowtext">
                  <div>抱歉，您还没有关注的圈子,</div>
                  <div>将默认发布至个人动态。</div>
                </div>
                <div class="gotofollow" @click.stop="gotofollow">
                  <button>立即去关注</button>
                </div>
              </div>

              <div v-else>
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
                  style="height:100%;overflow-y:hidden;"
                >
                  <div v-for="(item,index) in myfollowcircle" :key="index">
                    <div class="circle-cell">
                      <div class="circle-cell-pic">
                        <img :src="item.avatar_url" />
                      </div>
                      <div class="circle-cell-name">
                        <div class="cname">{{item.title}}</div>
                        <!--  <div class="ccontent">{{item.content}}</div>   -->
                        <div
                          class="ccontent"
                        >柜体保养篇：吊柜的承载力一般不如下柜，所以吊柜内适合放置比较轻的物品，如调味罐及玻璃杯等重物最好**下柜里；器皿应该清洗干净后再放入柜中，特别要注意的是要把器皿**干；橱柜中的五金件用干布**，避免水滴留在其表面造成水痕；料理台的水槽可以事先用细丝兜住内部滤盒，防止菜屑及细小残渣堵住水管。清洁篇：每次清洗水槽时，要记得把滤盒后的管部颈端一并清洗，以免长期堆积的油垢愈积愈多；如果油垢长期堆积在水槽管道内不易洗净，那么试试在水槽内倒一些厨房去油渍的清洁剂，用热水冲后，再以冷水冲。</div>
                      </div>
                      <div class="circle-cell-fllow" v-if="xzcircleindex == index+1">
                        <button>已选择</button>
                      </div>
                      <div
                        class="circle-cell-fllow circle-cell-fllowed"
                        :data-cname="item.title"
                        :data-cid="item.id"
                        :data-index="index+1"
                        @click.stop="getchoosecircle"
                        v-else
                      >
                        <button>选择</button>
                      </div>
                    </div>
                  </div>
                </van-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import navbar from "../public/navbar.vue";
import { getpubishcircle, getfollowcircle } from "../../api/api";
import { Toast, Field, Dialog } from "vant";
import { mapState } from "vuex";

import Vue from "vue";
Vue.use(Field);
import axios from "axios";
export default {
  name: "publish",
  components: {
    navbar
  },
  data() {
    return {
      titlename: "发布动态",
      fileList: [],
      videofile: [],
      textvalue: "",
      lastextra: [],
      circleicon: require("../../assets/images/dynamic_icon_qza.png"),
      currentshow: localStorage.getItem("currentshow") || false, //一开始圈子默认不展示选中
      circleid: 0, //圈子ID
      circlename: "不选择圈子", //默认选择的圈子名字
      circlecome: "false",
      showOncircle: false,
      nofollow: true, //当没有关注的状态
      myfollowcircle: [], //我关注的圈子
      page: 0, //分页请求
      pageCount: 0,
      msg_type: 0,
      loading: false,
      scrollTop: 0,
      finished: true,
      wxzcircle: true,
      xzcircleindex: null,
      circleIconNothing: require("../../assets/images/circle_icon_nothing.png"),
      circleIconWu: require("../../assets/images/circle_icon_wu.png")
    };
  },
  computed: {
    ...mapState(["baseAPI"])
  },
  created() {
    document.title = "发布";

    let hccirclename = localStorage.getItem("hccirclename");
    let hccircleid = localStorage.getItem("hccircleid");

    //存储的内容
    if (localStorage.getItem("textvalue")) {
      this.textvalue = localStorage.getItem("textvalue");
    } else {
      this.textvalue = "";
    }

    if (localStorage.getItem("lastextra")) {
      this.lastextra = JSON.parse(localStorage.getItem("lastextra"));
      if (typeof this.lastextra == "string") {
        //存储的视频
        this.videofile.push({ content: this.lastextra });
      } else {
        //存储的照片
        var obj = JSON.parse(localStorage.getItem("lastextra"));
        obj.forEach(ele => {
          this.fileList.push({ url: ele });
        });
      }
    } else {
      this.lastextra = [];
    }

    if (hccirclename) {
      this.circleid = hccircleid;
      this.circlename = hccirclename;
    }

    if (hccircleid != 0 || hccirclename != "") {
      this.currentshow = true;
    } else {
      this.currentshow = false;
    }

    if (this.$route.query.circlecome) {
      this.circlecome = "true";
      this.circlename = this.$route.query.circlename;
      this.circleid = this.$route.query.cid;
    } else {
      this.circlecome = "false";
    }

    let xzcircleindex = localStorage.getItem("xzcircleindex");

    if (xzcircleindex > 0) {
      this.wxzcircle = false;
      this.xzcircleindex = xzcircleindex;
    } else {
      this.wxzcircle = true;
      this.xzcircleindex = null;
    }

    let that = this;
    //获取关注过的圈子列表
    getfollowcircle().then(res => {
      //没有关注圈子
      if (res.data.code == 412) {
        that.nofollow = true;
        that.page = 0;
        that.pageCount = null;
      } else if (res.data.code == 200) {
        that.nofollow = false;
        that.myfollowcircle = res.data.data.list;
        that.pageCount = res.data.data.pageCount;
        that.finished = false;
      }
    });
  },
  watch: {
    textvalue(e) {
      localStorage.setItem("textvalue", e);
    }
  },
  methods: {
    verify: function() {
      var textvalue = this.textvalue;
      if (textvalue.length > 499) {
        Toast("内容文字不可以超过500个字");
      }
    },
    //返回
    onClickLeft() {
      let hccirclename = localStorage.getItem("hccirclename") || "";
      let textvalue = localStorage.getItem("textvalue") || "";
      let lastextra = localStorage.getItem("lastextra") || "";

      if (hccirclename != "" || textvalue != "" || lastextra != "") {
        Dialog.confirm({
          title: "提示",
          message: "是否保留编辑内容"
        })
          .then(() => {
            // on confirm
            this.$router.go(-1);
          })
          .catch(() => {
            // on cancel
            localStorage.setItem("hccirclename", "");
            localStorage.setItem("hccircleid", "");
            localStorage.setItem("currentshow", false);
            localStorage.setItem("xzcircleindex", null);
            localStorage.setItem("lastextra", "");
            localStorage.setItem("textvalue", "");
            /* localStorage.setItem("stupimgsrc",''); */
            this.$router.go(-1);
          });
      } else {
        this.$router.go(-1);
      }
    },
    //选择圈子
    showPopup() {
      this.showOncircle = true;
    },
    onLoad() {
      // 异步更新数据
      let that = this;

      setTimeout(() => {
        //let api_uid = this.dynamiccontent.api_uid;
        var page = this.page;
        //let that = this;
        let pageCount = this.pageCount - 1;
        page++;
        if (page > pageCount) {
          that.finished = true;
          that.loading = false;
          return;
        }
        this.page = page;

        getfollowcircle(page).then(res => {
          if (res.data.code == 200) {
            this.loading = false;
            let myfollowcircle = that.myfollowcircle;
            let newarr = res.data.data.list;
            newarr.forEach(function(e) {
              myfollowcircle.push(e);
            });
          } else {
            that.finished = true;
            that.loading = false;
          }
        });
      }, 500);
    },
    clearvideo() {
      this.videofile = [];
      localStorage.setItem("lastextra", "");
    },
    videoRead(file) {
      let videosize = this.videofile.length;
      let baseURL = this.baseAPI;
      let that = this;
      //上传视频
      const toastload = Toast.loading({
        mask: true,
        message: "视频上传中..."
      });

      var base64String = this.videofile[0].file;
      var formData = new FormData();
      formData.append("file", base64String);
      axios.defaults.timeout = 30000;
      axios.defaults.headers.common["PLATFORM"] = "H5";
      //上传
      const instance = axios.create({
        withCredentials: false
      });

      instance
        .post(baseURL + "/file-bases/videos", formData)
        .then(res => {
          if (res.data.code == 200) {
            that.lastextra.push(res.data.data.url);
            localStorage.setItem(
              "lastextra",
              JSON.stringify(res.data.data.url)
            );
            toastload.clear();
          }
        })
        .catch(function(error) {
          Toast.fail("视频上传失败,请重试！");
        });
    },
    afterRead(file) {
      //this.lastextra = [];
      let fileArr = [];
      if (file instanceof Array) {
        fileArr = file;
      } else {
        fileArr.push(file);
      }

      let filesize = fileArr.length;
      let baseURL = this.baseAPI;
      var num = 0;
      let that = this;
      //上传图片

      const toastload = Toast.loading({
        mask: true,
        message: "上传图片中..."
      });

      for (var i = 0; i < filesize; i++) {
        var base64String = fileArr[i].content;
        //这里对base64串进行操作，去掉url头，并转换为byte
        var bytes = window.atob(base64String.split(",")[1]);

        //处理异常，将ASCII码小于0的转换为大于0，这里有两种写法

        var ab = new ArrayBuffer(bytes.length);
        var ia = new Uint8Array(ab);
        for (var j = 0; j < bytes.length; j++) {
          ia[j] = bytes.charCodeAt(j); //这里有点疑惑，ia是怎么改变ab的？注：①
        }
        //Blob对象
        var blob = new Blob([ab], { type: "image/jpeg" }); //type为图片的格式
        //FormData对象
        var formData = new FormData();

        formData.append("file", blob, Date.now() + ".jpg");
        formData.append("type", "message");
        axios.defaults.timeout = 30000;
        //上传
        const instance = axios.create({
          withCredentials: false
        });

        instance
          .post(baseURL + "/file-bases/images", formData)
          .then(res => {
            if (res.data.code == 200) {
              that.lastextra.push(res.data.data.url);
              num++;
              if (num == filesize) {
                toastload.clear();
                localStorage.setItem(
                  "lastextra",
                  JSON.stringify(that.lastextra)
                );
                that.fileList = [];
                that.lastextra.forEach(ele => {
                  that.fileList.push({ url: ele });
                });
              }
            }
          })
          .catch(function(error) {
            Toast.fail("上传失败,请重试！");
          });
      }
    },

    isObjectValueEqual(a, b) {
      //取对象a和b的属性名
      var aProps = Object.getOwnPropertyNames(a);
      var bProps = Object.getOwnPropertyNames(b);
      //判断属性名的length是否一致
      if (aProps.length != bProps.length) {
        return false;
      }
      //循环取出属性名，再判断属性值是否一致
      for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
          return false;
        }
      }
      return true;
    },

    deleteImg(file) {
      let that = this;
      that.fileList.forEach((e, index) => {
        if (that.isObjectValueEqual(e, file)) {
          that.lastextra.splice(index, 1);
          localStorage.setItem("lastextra", JSON.stringify(that.lastextra));
        }
      });
      return true;
    },
    updatatogo() {
      let lastextra = this.lastextra;
      let filesize = this.fileList.length;
      let videosize = this.videofile.length;
      let baseURL = this.baseAPI;
      let textvalue = this.textvalue;
      let that = this;

      if (textvalue.length > 500) {
        Toast("内容文字不可以超过500个字！");
        return;
      }

      var num = 0;

      let like_id = this.circleid;

      if (filesize > 0) {
        //上传图片

        const toastload = Toast.loading({
          mask: true,
          message: "发布中..."
        });

        let msg_type = 1;

        getpubishcircle(textvalue, msg_type, like_id, lastextra).then(res => {
          if (res.code == 200) {
            localStorage.setItem("hccirclename", "");
            localStorage.setItem("hccircleid", "");
            localStorage.setItem("currentshow", false);
            localStorage.setItem("xzcircleindex", null);
            localStorage.setItem("textvalue", "");
            localStorage.setItem("lastextra", "");
            //返回上级
            this.$router.go(-1);
            toastload.clear();
            Toast.success("提交成功");
          } else if (res.code == 412) {
            Toast.fail("发布失败，请重试！");
          } else {
            Toast.fail("发布失败，请重试！");
          }
        });
      } else if (videosize > 0) {
        //上传视频

        const toastload = Toast.loading({
          mask: true,
          message: "发布中..."
        });

        let msg_type = 2;

        getpubishcircle(textvalue, msg_type, like_id, lastextra).then(res => {
          if (res.code == 200) {
            //返回上级
            //Toast.clear();
            localStorage.setItem("hccirclename", "");
            localStorage.setItem("hccircleid", "");
            localStorage.setItem("currentshow", false);
            localStorage.setItem("xzcircleindex", null);
            localStorage.setItem("textvalue", "");
             localStorage.setItem("lastextra", "");
            this.$router.go(-1);
            toastload.clear();
            Toast.success("发布成功");
          } else if (res.code == 412) {
            Toast.fail("发布失败");
          } else {
            Toast.fail("发布失败");
          }
        });
      } else if (filesize == 0 && videosize == 0 && textvalue.length == 0) {
        Toast.fail("内容不能为空");
      } else {
        let msg_type = 1;

        const toastload = Toast.loading({
          mask: true,
          message: "发布中..."
        });
        getpubishcircle(textvalue, msg_type, like_id, lastextra)
          .then(res => {
            if (res.code == 200) {
              localStorage.setItem("hccirclename", "");
              localStorage.setItem("hccircleid", "");
              localStorage.setItem("currentshow", false);
              localStorage.setItem("xzcircleindex", null);
              localStorage.setItem("textvalue", "");
              //ocalStorage.setItem("fileList",'');
              //localStorage.setItem("videofile",'');
              //返回上级
              this.$router.go(-1);
              toastload.clear();
              Toast.success("发布成功");
            } else if (res.code == 412) {
              Toast.fail("发布失败");
            } else {
              Toast.fail("发布失败");
            }
          })
          .catch(function(error) {
            Toast.fail("发布失败,请重试！");
          });
      }
    },
    //圈子的选择
    getchoosecircle(e) {
      let circleid = e.currentTarget.dataset.cid;
      let circlename = e.currentTarget.dataset.cname;
      let xzcircleindex = e.currentTarget.dataset.index;
      this.circlename = e.currentTarget.dataset.cname;
      this.circleid = e.currentTarget.dataset.cid;
      this.xzcircleindex = e.currentTarget.dataset.index;

      if (circleid > 0) {
        this.wxzcircle = false;
      } else {
        this.wxzcircle = true;
      }

      localStorage.setItem("xzcircleindex", xzcircleindex);

      this.showOncircle = false;

      if (circleid > 0) {
        localStorage.setItem("hccirclename", circlename);
        localStorage.setItem("hccircleid", circleid);
        localStorage.setItem("currentshow", true);
      } else {
        this.currentshow = false;
        localStorage.setItem("hccirclename", "");
        localStorage.setItem("hccircleid", circleid);
        localStorage.setItem("currentshow", false);
      }

      let that = this;
      getfollowcircle().then(res => {
        //没有关注圈子
        if (res.data.code == 412) {
          that.nofollow = true;
          that.page = 0;
          that.pageCount = null;
        } else if (res.data.code == 200) {
          that.nofollow = false;
          that.myfollowcircle = res.data.data.list;
          that.pageCount = res.data.data.pageCount;
        }
      });
    }
  }
};
</script>

<style scoped>
.publish_containter{
    width: 100%;
    height: 100%;
    background: #fff;
}
.van-nav-bar {
  height: 50px;
  line-height: 50px;
  position: fixed;
  width: 100%;
  border-bottom: 1px solid #eee;
  overflow: hidden;
}
.van-nav-bar__title {
  font-weight: bold;
  font-size: 0.8rem;
}
.van-icon-arrow-left:before {
  color: #333;
  font-size: 1rem;
}
.xuanzetitle {
  text-align: center;
  font-size: 0.82rem;
  padding-bottom: 0.8rem;
  padding-top: 0.8rem;
}
.publishbox .currentcircle {
  border-bottom: 1px solid #f2f2f2;
  /*  padding-bottom: 0.8108108108108109rem;
     margin-left: 0.8108108108108109rem;
     margin-right: 0.8108108108108109rem; */
  padding: 0.8108108108108109rem 0;
  margin-bottom: 0.5rem;
  /*  padding-top: 50px; */
}
.publishbox .currentcircle img {
  width: 0.918918918918919rem;
  height: 0.8918918918918919rem;
  margin-bottom: -0.118919rem;
}
.publishbox .currentcircle span {
  color: #ffbd0a;
  font-size: 0.8108108108108109rem;
  /*  padding-left: 0.2702702702702703rem; */
}
.publishbox .currentcircle .righticon {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  transform: rotate(45deg);
  float: right;
  /*  color: #ccc; */
  margin-top: 0.4rem;
}
.publishbox {
  padding-left: 0.6486486486486487rem;
  padding-right: 0.6486486486486487rem;
  /* padding-top: 0.8648648648648649rem; */
  padding-top: 50px;
}
.publishbox textarea {
  width: 100%;
  border: none;
  font-size: 0.8108108108108109rem;
  height: 10rem;
  margin-top: 0.6rem;
}
.publishimgbox {
  padding-left: 0.62rem;
  padding-bottom: 6.5rem;
  overflow: hidden;
}

.publishdown {
  bottom: 0;
  position: fixed;
  left: 0;
  width: 100%;
  background: #fff;
}
.publishdown .choosecircle {
  padding-left: 0.8108108108108109rem;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.8108108108108109rem;
}
.publishdown .choosecircle img {
  width: 0.918918918918919rem;
  height: 0.8918918918918919rem;
  margin-bottom: -0.05405405405405406rem;
}
.publishdown .choosecircle span {
  color: #666;
  font-size: 0.8108108108108109rem;
  padding-left: 0.2702702702702703rem;
}
.publishdown .publishhandle {
  border-top: 1px solid #f2f2f2;
  padding-top: 0.6756756756756757rem;
  overflow: hidden;
  padding-bottom: 0.6756756756756757rem;
}
.publishdown .publishhandle .handleiconbox {
  padding-top: 0.35135135135135137rem;
}
.publishdown .publishhandle .handleiconbox .handleicon01 {
  float: left;
  padding-left: 0.8108108108108109rem;
}
.publishdown .publishhandle .handleiconbox .handleicon01 img {
  width: 1.5135135135135136rem;
  height: 1.0810810810810811rem;
}
.publishdown .publishhandle .handleiconbox .handleicon02 {
  float: left;
  padding-left: 1.4864864864864864rem;
}
.publishdown .publishhandle .handleiconbox .handleicon02 img {
  width: 1.3513513513513513rem;
  height: 1.0810810810810811rem;
}
.publishdown .publishbtn {
  float: right;
  padding-right: 0.8108108108108109rem;
}
.publishdown .publishbtn .cu-btn-fsbtn {
  width: 3.135135135135135rem;
  height: 1.7297297297297298rem;
  border-radius: 1.0810810810810811rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  border: none;
  font-size: 0.75rem;
  color: #fff;
}

.videoshowbox {
  margin-left: 0.8rem;
  margin-right: 1rem;
  background: #000;
  position: relative;
}
.videoshowbox .closespan {
  position: absolute;
  right: -0.65rem;
  top: -0.65rem;
  font-size: 1.5rem;
  border-radius: 50%;
  z-index: 100;
  color: #333;
  background: #fff;
  height: 1.55rem;
}

.choosecirclebox {
  border-top: 0.02702702702702703rem solid #f3f3f3;

  padding-left: 0.8108108108108109rem;
  padding-right: 0.2702702702702703rem;
}
.choosecirclebox .followtitlebox {
  padding-bottom: 0.5405405405405406rem;
  background: #fff;
}
.choosecirclebox .followtitle {
  margin-top: 0.8108108108108109rem;
  font-size: 0.8108108108108109rem;
  border-left: 0.2702702702702703rem solid #ffbd0a;
  padding-left: 0.5405405405405406rem;
  font-weight: bold;
}
.choosecirclebox .followmain .scroll-box {
  padding-bottom: 1.3513513513513513rem;
}
.choosecirclebox .followmain .circle-cell {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.8108108108108109rem;
  border-bottom: 0.02702702702702703rem solid #f6f6f6;
}
.choosecirclebox .followmain .circle-cell .circle-cell-pic {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  flex: 2 1 2.4324324324324325rem;
  width: 2.4324324324324325rem;
  position: relative;
}
.choosecirclebox .followmain .circle-cell .circle-cell-pic .circle-cell-pic-no {
  position: absolute;
  bottom: 0;
  background: rgba(218, 135, 70, 0.9);
  height: 0.7027027027027027rem;
  line-height: 0.7027027027027027rem;
  width: 2.108108108108108rem;
  color: #fff;
  font-size: 0.4864864864864865rem;
  text-align: center;
  border-radius: 0 0 0.2702702702702703rem 0.2702702702702703rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-pic img {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
}
.choosecirclebox
  .followmain
  .circle-cell
  .circle-cell-pic
  .circle-cell-pic-no
  img {
  width: 0.7567567567567568rem;
  height: 0.5675675675675675rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-name {
  width: 10.81081081081081rem;
  flex: 7 1 10.81081081081081rem;
  padding-right: 0.2702702702702703rem;
  padding-left: 0.2702702702702703rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-name .cname {
  font-size: 0.7567567567567568rem;
  padding-bottom: 0.16216216216216217rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-name .ccontent {
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  font-size: 0.6486486486486487rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-fllow {
  padding-top: 0.2702702702702703rem;
  flex: 1 1 4.054054054054054rem;
  width: 4.054054054054054rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-fllow button {
  font-size: 0.6486486486486487rem;
  border: 1px solid #ffbd0a;
  width: 3.2432432432432434rem;
  line-height: 1.5rem;
  display: block;
  color: #fff;
  background: #ffffff;
  padding: 0;
  color: #ffbd0a;
  border-radius: 5px;
  margin: 0 auto;
}
button:after {
  border: none;
}
.choosecirclebox .followmain .circle-cell .circle-cell-fllowed button {
  font-size: 0.6486486486486487rem;
  width: 3.2432432432432434rem;
  line-height: 1.5rem;
  display: block;
  color: #fff;
  background: #ffbd0a;
  padding: 0;
  color: #fff;
  border-radius: 5px;
  margin: 0 auto;
}
.choosecirclebox .nochoosecircle .circle-cell {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.8108108108108109rem;
  border-bottom: 0.02702702702702703rem solid #f6f6f6;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-pic {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  flex: 2 1 2.4324324324324325rem;
  width: 2.4324324324324325rem;
  position: relative;
}
.choosecirclebox
  .nochoosecircle
  .circle-cell
  .circle-cell-pic
  .circle-cell-pic-no {
  position: absolute;
  bottom: 0;
  background: rgba(218, 135, 70, 0.9);
  height: 0.7027027027027027rem;
  line-height: 0.7027027027027027rem;
  width: 2.108108108108108rem;
  color: #fff;
  font-size: 0.4864864864864865rem;
  text-align: center;
  border-radius: 0 0 0.2702702702702703rem 0.2702702702702703rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-pic img {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-name {
  width: 10.81081081081081rem;
  flex: 7 1 10.81081081081081rem;
  padding-right: 0.2702702702702703rem;
  padding-left: 0.2702702702702703rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-name .cname {
  font-size: 0.7567567567567568rem;
  padding-top: 0.5135135135135135rem;
  padding-bottom: 0.16216216216216217rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-fllow {
  padding-top: 0.2702702702702703rem;
  flex: 1 1 4.054054054054054rem;
  width: 4.054054054054054rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-fllow button {
  font-size: 0.6486486486486487rem;
  border: 1px solid #ffbd0a;
  width: 3.2432432432432434rem;
  line-height: 1.5rem;
  display: block;
  color: #fff;
  background: #ffffff;
  padding: 0;
  color: #ffbd0a;
  border-radius: 5px;
  margin: 0 auto;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-fllowed button {
  font-size: 0.6486486486486487rem;
  width: 3.2432432432432434rem;
  line-height: 1.5rem;
  display: block;
  color: #fff;
  background: #ffbd0a;
  padding: 0;
  color: #fff;
  border-radius: 5px;
  margin: 0 auto;
}
button:after {
  border: none;
}
.choosecirclebox .nofollowbox {
  padding-top: 5.405405405405405rem;
}
.choosecirclebox .nofollowbox .nofollowtext {
  text-align: center;
  padding-top: 0.8108108108108109rem;
  color: #999;
  font-size: 0.72rem;
}
.choosecirclebox .nofollowbox .nofollowpic {
  text-align: center;
}
.choosecirclebox .nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.choosecirclebox .nofollowbox .gotofollow {
  padding-top: 1.2702702702702702rem;
  text-align: center;
}
.choosecirclebox .nofollowbox .gotofollow button {
  width: 5.405405405405405rem;
  height: 1.8918918918918919rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  font-size: 0.7567567567567568rem;
  color: #fff;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/publish.vue